<template>
  <div class="customer-note">
      <div class="customer-note-buttons-container customer-note-buttons-container-mobile">
          <button v-if="!is_note_editing" type="submit" @click="updateNoteEditingMobile" name="submit" class="btn btn--primary">
              Edit
          </button>
          <button v-if="is_note_editing" type="submit" @click="updateNoteMobile" :id="customer_note.id" name="submit" class="btn btn--primary">
              Update
          </button>
          <button v-if="!is_note_editing" @click="removeCustomerNote" :key="customer_note.id" :id="customer_note.id" type="submit" name="submit" class="btn btn--warning">
              Remove
          </button>
      </div>
      <div v-if="!is_note_editing" class="customer-note-container">
          <p class="customer-note-content">{{ customer_note.content }}</p>
          <span class="customer-note-date">{{ createdAt }}</span>
      </div>
      <div v-if="is_note_editing" class="customer-note-container">
        <textarea :value="updated_customer_note" @change="setCustomerNote"/>
      </div>
      <div class="customer-note-buttons-container customer-note-buttons-container-desktop">
          <button v-if="is_note_editing" type="submit" @click="updateNote" :id="customer_note.id" name="submit" class="btn btn--primary">
              Update
          </button>
          <button v-if="!is_note_editing" type="submit" @click="updateNoteEditing" name="submit" class="btn btn--primary">
              Edit
          </button>
          <button v-if="!is_note_editing" @click="removeCustomerNote" :key="customer_note.id" :id="customer_note.id" type="submit" name="submit" class="btn btn--warning">
              Remove
          </button>
      </div>
  </div>
</template>

<script>
import api from '../api'
import moment from 'moment'

export default {
  name: 'Customer notes',
  props: {
    customer_id: {
      type: String,
      default: null,
    },
    new_customer_note: {
      type: String,
      default: null
    },
    customer_note: {
      type: Object
    },
  },
  data() {
    return {
      updated_customer_note: this.customer_note.content,
      is_note_editing: false,
    }
  },
  emits: ["customerNoteDeleted"],
  methods: {
    setCustomerNote(event) {
      this.updated_customer_note = event.target.value
    },
    updateNoteMobile(e) {
      this.$el.scrollLeft += 600
      this.updateNote(e)
    },
    updateNote(e) {
      e.preventDefault()
      this.is_note_editing = false
      let params = {
        customer_id: this.$props.customer_id,
        id: e.target.id,
        content: this.updated_customer_note
      }
      api.updateCustomerNote(params).then(customer_note => {
        this.$emit('customerNoteDeleted', customer_note, e.target)
      })
    },
    updateNoteEditingMobile(e) {
      this.$el.scrollLeft += 300
      this.updateNoteEditing(e)
    },
    updateNoteEditing(e) {
      e.preventDefault()
      let prevValue = !this.is_note_editing
      this.is_note_editing = prevValue
    },
    removeCustomerNote(e) {
      e.preventDefault()
      let params = {
        customer_id: this.$props.customer_id,
        id: e.target.id
      }
      api.deleteCustomerNote(params).then(customer_note => {
        this.$emit('customerNoteDeleted', customer_note, e.target)
      })
    },
  },
  computed: {
    createdAt() {
      return moment(this.customer_note.created_at).format('M/D/YYYY');
    }
  },
  mounted() {
    this.$el.scrollLeft += 600
  }
}

</script>

<style scoped>
textarea {
  resize: none;
  padding: 8px;
  height: 100px;
  min-width: 100%;
  resize: none;
  border: 1px solid #E5E5E5;
}

.customer-note {
  display: flex;
  margin: 20px 0;
}

.customer-note-content {
  white-space: pre-line;
  line-height: 0.8;
  margin: 5px 0 20px;
  white-space: pre;
}

.customer-note-container {
  max-width: 75%;
  min-width: 75%;
  margin-right: 10px;
  border: 1px solid #E5E5E5;
  padding: 8px;
  background-color: white;
  position: relative;
}

.customer-note-buttons-container {
  width: 100%;
}

.customer-note-buttons-container-mobile {
  display: none;
}

.customer-note-date {
  position: absolute;
  bottom: 5px;
  right: 5px;
}

@media screen and (max-width: 992px) {
  .customer-note {
    overflow: scroll;
  }
  .customer-note-container {
    min-width: 100%;
    margin-right: 0;
    min-height: 80px;

  }

  .customer-note-buttons-container-desktop {
    display: none;
  }

  .customer-note-buttons-container-mobile {
    display: flex;
  }

  .btn {
    min-width: 100px;
    max-height: 40px;
    margin: 0 5px;
  }
}
</style>
